// 应用信息接口定义
export interface AppInfo {
  id?: string
  name: string
  type: string
  category: string
  code: string
  subscriptionCount?: number
  description?: string
}

// 应用列表数据
export const appList: AppInfo[] = [
    {
        id: '1',
        name: 'WMS',
        type: 'Web页面应用',
        category: '仓储物流',
        code: 'mold-lifecycle-app',
        subscriptionCount: 0,
        description: ''
    },
    {
        id: '2',
        name: 'WMS移动版APP',
        type: '移动端应用',
        category: '仓储物流',
        code: 'wms-mobile',
        subscriptionCount: 0,
        description: ''
    },
    {
        id: '3',
        name: '园区车辆预约APP',
        type: '移动端应用',
        category: '运营管理',
        code: 'vehicle-appointment',
        subscriptionCount: 0,
        description: ''
    },
    {
        id: '4',
        name: '供应链智能运输APP',
        type: '小程序应用',
        category: '仓储物流',
        code: 'smart-transport-app',
        subscriptionCount: 0,
        description: ''
    },
    {
        id: '5',
        name: '远程控制与操作类APP',
        type: '移动端应用',
        category: '生产制造',
        code: 'remote-control-app',
        subscriptionCount: 0,
        description: ''
    },    
    {
        id: '6',
        name: 'AGV调度系统（ROS/TCS）',
        type: '服务端应用',
        category: '仓储物流',
        code: 'agv-dispatch-system',
        subscriptionCount: 0,
        description: ''
    },
    {
        id: '7',
        name: '订单排程优化APP',
        type: '桌面端应用',
        category: '生产制造',
        code: 'order-scheduling-app',
        subscriptionCount: 0,
        description: ''
    },
    {
        id: '8',
        name: '质量追溯APP',
        type: 'Web页面应用',
        category: '质量管控',
        code: 'quality-tracking-app',
        subscriptionCount: 0,
        description: ''
    },
    {
        id: '9',
        name: '能源管理APP',
        type: 'Web页面应用',
        category: '节能减排',
        code: 'energy-management-app',
        subscriptionCount: 0,
        description: ''
    },
    {
        id: '10',
        name: '智能装箱规划APP',
        type: '桌面端应用',
        category: '生产制造',
        code: 'smart-packing-app',
        subscriptionCount: 0,
        description: ''
    },
    {
        id: '11',
        name: '设备预测性维护APP',
        type: '数据采集器',
        category: '运维服务',
        code: 'predictive-maintenance-app',
        subscriptionCount: 0,
        description: ''
    },
    {
        id: '12',
        name: '供应商协同APP',
        type: 'Web页面应用',
        category: '运营管理',
        code: 'supplier-collaboration-app',
        subscriptionCount: 0,
        description: ''
    },
    {
        id: '13',
        name: '标签自动识别匹配APP',
        type: '移动端应用',
        category: '质量管控',
        code: 'auto-tag-matching-app',
        subscriptionCount: 0,
        description: ''
    },
    {
        id: '14',
        name: 'DataHub微服务',
        type: '数据采集器',
        category: '运营管理',
        code: 'datahub-service',
        subscriptionCount: 0,
        description: ''
    },
    {
        id: '15',
        name: 'AGV快速路径微服务',
        type: '数据采集器',
        category: '运维服务',
        code: 'agv-path-service',
        subscriptionCount: 0,
        description: ''
    },
    {
        id: '16',
        name: '自动化立库控制APP',
        type: '移动端应用',
        category: '仓储物流',
        code: 'auto-warehouse-control-app',
        subscriptionCount: 0,
        description: ''
    },
    {
        id: '17',
        name: '集装箱装箱预测APP',
        type: 'Web页面应用',
        category: '仓储物流',
        code: 'container-packing-prediction-app',
        subscriptionCount: 0,
        description: ''
    },
    {
        id: '18',
        name: '电子标签管理系统',
        type: 'Web页面应用',
        category: '仓储物流',
        code: 'e-label-management-system',
        subscriptionCount: 0,
        description: ''
    },
    {
        id: '19',
        name: '物流路径优化APP',
        type: 'Web页面应用',
        category: '仓储物流',
        code: 'logistics-path-optimization-app',
        subscriptionCount: 0,
        description: ''
    },
    {
        id: '20',
        name: '模具全生命周期APP',
        type: 'Web页面应用',
        category: '生产制造',
        code: 'mold-lifecycle-app',
        subscriptionCount: 0,
        description: ''
    },{
        id: '21',
        name: '设备状态跟踪系统',
        type: '数据采集器',
        category: '运维服务',
        code: 'device-status-tracker',
        subscriptionCount: 0,
        description: ''
    }
]